import { createClient } from "@supabase/supabase-js";

// Lemos exatamente o que você definiu no seu .env
const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

// Validação de segurança para você saber exatamente o que está errado
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Erro de Configuração: VITE_PUBLIC_SUPABASE_URL ou VITE_PUBLIC_SUPABASE_ANON_KEY não foram encontrados no seu arquivo .env.");
}

// Cria o cliente oficial
export const supabase = createClient(supabaseUrl, supabaseAnonKey);